import { useMutation } from '@tanstack/react-query';
import { useApi } from '../../lib/api';

interface ErrorBody {
  error?: string;
  message?: string;
}

export interface GrantError extends Error {
  status?: number;
  body?: ErrorBody;
}

function toError(stage: string, response: Response | undefined, error: unknown): GrantError {
  const e = new Error(stage) as GrantError;
  if (response) e.status = response.status;
  e.body = (error ?? {}) as ErrorBody;
  return e;
}

/**
 * Grants standalone OAuth consent (no `authorize_request_id` since this is
 * the device flow, not a browser /auth/authorize hop). Used between the
 * device-verify "consent_required" response and the second verify call.
 */
export function useGrantStandaloneConsent() {
  const api = useApi();
  return useMutation<void, GrantError, { client_id: string; scopes: string[] }>({
    mutationFn: async ({ client_id, scopes }) => {
      const { error, response } = await api.POST('/auth/consents', { body: { client_id, scopes } });
      if (error) throw toError('consent_grant_failed', response, error);
    },
  });
}
